module.exports = __webpack_public_path__ + "static/media/jp.a1e1ea51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/jp.svg
// module id = 159
// module chunks = 0